var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.178,
    height: 81.178,
    viewBox: "0 0 81.178 81.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(-1129.411 -131.911)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(1133 135)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "robot_1_",
    "data-name": "robot (1)",
    transform: "translate(1129.411 131.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(14.428 10.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_239561336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_239561696",
    d: "M16.442,35.024a3.639,3.639,0,0,1-2.34,3.551,4.188,4.188,0,0,1-3.1,0,3.639,3.639,0,0,1-2.34-3.551c0-.706-.019-1.408-.04-2.168-.044-1.583-.094-3.4-.017-4.776H2.875a.968.968,0,0,1-.968-.968V2.951h35.8V27.111a.968.968,0,0,1-.968.968H31.964v6.945a3.657,3.657,0,0,1-2.336,3.569,4.189,4.189,0,0,1-3.109,0,3.657,3.657,0,0,1-2.336-3.569c0-1.618.03-3.6.061-5.578q.01-.684.021-1.367H16.35c.007.454.015.915.023,1.376.034,1.96.068,3.923.068,5.569Z",
    transform: "translate(6.345 21.989)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_239561936",
    d: "M10.346,12.009a3.639,3.639,0,0,1-2.34,3.551,4.188,4.188,0,0,1-3.1,0,3.639,3.639,0,0,1-2.34-3.551c0-.706-.019-1.408-.04-2.168-.044-1.583-.094-3.4-.017-4.776h7.747c.007.454.015.915.023,1.376.034,1.96.068,3.923.068,5.569ZM25.868,5.064v6.945a3.657,3.657,0,0,1-2.336,3.569,4.189,4.189,0,0,1-3.109,0,3.657,3.657,0,0,1-2.336-3.569c0-1.618.03-3.6.061-5.578q.01-.684.021-1.367h7.7Z",
    transform: "translate(12.441 45.004)",
    fill: "#699539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_239561600",
    d: "M5.188,1.344,8.3,4.456a20.421,20.421,0,0,0-3.215,1.52L2.82,3.711A1.674,1.674,0,1,1,5.188,1.344ZM27.594,3.711,25.33,5.975a20.421,20.421,0,0,0-3.215-1.52l3.112-3.112a1.674,1.674,0,1,1,2.368,2.367Z",
    transform: "translate(10.946 -0.853)",
    fill: "#699539",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_239561888",
    d: "M8.267,2.639a3.2,3.2,0,0,1,3.19,3.19V18.942a3.19,3.19,0,0,1-6.38,0V5.829a3.2,3.2,0,0,1,3.19-3.19Z",
    transform: "translate(40.86 18.592)",
    fill: "#699539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_239562176",
    d: "M4.4,2.639a3.2,3.2,0,0,1,3.19,3.19V18.942a3.19,3.19,0,0,1-6.38,0V5.829A3.2,3.2,0,0,1,4.4,2.639Z",
    transform: "translate(-1.213 18.592)",
    fill: "#699539"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_239562152",
    d: "M1.886,18.565A16.237,16.237,0,0,0,2.157,21.5l.146.794H37.775l.146-.794a16.237,16.237,0,0,0,.271-2.931A17.093,17.093,0,0,0,33.86,7.348,18.577,18.577,0,0,0,23.275,1.3a17.754,17.754,0,0,0-6.473,0A18.577,18.577,0,0,0,6.218,7.348,17.093,17.093,0,0,0,1.886,18.565Z",
    transform: "translate(6.115 0.766)",
    fill: "#7cb342",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_239561744",
    d: "M2.589,3.652A1.872,1.872,0,1,0,4.461,1.78,1.872,1.872,0,0,0,2.589,3.652Z",
    transform: "translate(13.77 9.243)",
    fill: "#fffffe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_239561504",
    d: "M3.922,3.652A1.872,1.872,0,1,0,5.793,1.78,1.872,1.872,0,0,0,3.922,3.652Z",
    transform: "translate(28.283 9.243)",
    fill: "#fffffe",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M0,0H81.178V81.178H0Z",
    fill: "none",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidLogo);
export default __webpack_public_path__ + "static/media/androidLogo.fda8f4d439f790fa1c66cb7cc10bbe9a.svg";
export { ForwardRef as ReactComponent };